// 支持翻页的Table组件
import './index.less';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import { Button, Pagination, Select, Table } from 'antd';
import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import { cache } from 'utils';

class PaginationTable extends (PureComponent || Component) {
	constructor (props) {
		super(props);
		this.state = {
			// 每页数量
			pageSize: props.defaultPageSize || props.pageSize[0],
			// 前一页，当前页，下一页锚点
			currentPageAnchor: null,
			nextPageAnchor: null,
			prevPageAnchor: null,
			// 缓存前一页数据
			cachePrevPageAnchor: [],
			// 翻页按钮禁用状态
			nextPageAnchorDisabled: !props.pageAnchor,
			prevPageAnchorDisabled: true,
			// 当前是否在加载标记
			loading: true,
			// 是否隐藏Table
			hideTable: false
		};
	}

	componentWillReceiveProps (nextProps) {
		const { pageAnchor } = nextProps;
		// 通过props拿到的pageAnchor永远是下一页锚点
		this.setState({ nextPageAnchor: pageAnchor, loading: false });
		// 如果后台没有返回锚点信息说明是最后一页，下一页按钮禁用,否则不禁用
		if (pageAnchor === undefined || pageAnchor === 'undefined') {
			this.setState({ nextPageAnchorDisabled: true });
		} else {
			this.setState({ nextPageAnchorDisabled: false });
		}
		// 如果缓存中没有前一页的锚点数据说明是第一页，前一页按钮禁用
		if (this.state.cachePrevPageAnchor.length === 0) {
			this.setState({ prevPageAnchorDisabled: true });
		} else {
			this.setState({ prevPageAnchorDisabled: false });
		}
	}

	componentDidMount () {
		// 如果是缓存了数据，需要在重新挂载组件的时候，利用缓存的数据初始化组件
		const { cacheData = true, cacheKey } = this.props;
		let cachedParams = null;
		if (cacheKey) {
			cachedParams = cache.getPageState('PaginationTable', cacheKey);
		} else {
			cachedParams = cache.getPageState('PaginationTable', 'paginationTable');
		}
		if (cacheData && cachedParams && 'pageSize' in cachedParams) {
			this.setState({
				pageSize: cachedParams.pageSize,
				currentPageAnchor: cachedParams.currentPageAnchor,
				nextPageAnchor: cachedParams.nextPageAnchor,
				prevPageAnchor: cachedParams.prevPageAnchor,
				cachePrevPageAnchor: cachedParams.cachePrevPageAnchor,
				nextPageAnchorDisabled: cachedParams.nextPageAnchorDisabled,
				prevPageAnchorDisabled: cachedParams.prevPageAnchorDisabled
			});
		} else {
			// this.props.onPageChange(this.props.pageSize[0], undefined);
		}
	}

	componentWillUnmount () {
		const { cacheData } = this.props;
		if (cacheData) {
			this.cachedParams();
		}
	}

	/**
	 * 如果使用了缓存，获取当前页数据；否则是第一页
	 * params：Object { success: 成功回调, error: 失败回调, otherParams: 业务自己需要的参数 }
	 */
	fetchByCacheParams = commandObject => {
		const { cacheData = true, cacheKey } = this.props;
		const {
			success = () => {
			}, error = () => {
			}, otherParams = {}
		} = commandObject || {};
		const newCommanObject = { success, error, otherParams };
		let cachedParams = null;
		if (cacheKey) {
			cachedParams = cache.getPageState('PaginationTable', cacheKey);
		} else {
			cachedParams = cache.getPageState('PaginationTable', 'paginationTable');
		}

		if (cacheData && cachedParams && 'pageSize' in cachedParams) {
			this.props.onPageChange(cachedParams.pageSize, cachedParams.currentPageAnchor, newCommanObject);
			this.setState({
				...cachedParams
			});
		} else {
			this.props.onPageChange(this.props.pageSize[0], undefined, newCommanObject);

			this.setState({
				pageSize: this.props.pageSize[0],
				currentPageAnchor: null,
				nextPageAnchor: null,
				prevPageAnchor: null,
				cachePrevPageAnchor: [],
				nextPageAnchorDisabled: false,
				prevPageAnchorDisabled: false
			});
		}
		this.clearCache();
	};

	// 点击上一页
	handlePrevClick = () => {
		const { loading } = this.props;
		const { cachePrevPageAnchor, currentPageAnchor, pageSize } = this.state;
		if (!loading) {
			const { onPageChange } = this.props;
			// 缓存删除最后一位记录，拿到该记录做当前请求的锚点
			const prevPageAnchor = cachePrevPageAnchor.pop();
			// 点击上一页，当前页是缓存中的最后一个锚点，下一个页的锚点为当前页的锚点，能点击前一页，则下一个一定能点击
			this.setState({
				cachePrevPageAnchor,
				currentPageAnchor: prevPageAnchor,
				nextPageAnchor: currentPageAnchor,
				nextPageAnchorDisabled: false
			});
			// 回调请求接口，把页码和请求需要的锚点传过去
			onPageChange(pageSize, prevPageAnchor);
		}
	};

	// 刷新当前页面的方法，在新增、修改、删除后操作，如果新增的记录不在当前页则看不到数据咯，需要上下翻页看到最新的数据(firstPageRefresh为true:刷新并回到第一页)
	refresh = (firstPageRefresh, commandObject) => {
		const { pageSize, currentPageAnchor } = this.state;
		this.commandObject = commandObject;
		const { onPageChange } = this.props;
		if (firstPageRefresh) {
			this.setState({
				nextPageAnchor: null,
				currentPageAnchor: null,
				prevPageAnchor: null,
				cachePrevPageAnchor: [],
				prevPageAnchorDisabled: false,
				nextPageAnchorDisabled: false
			});
			onPageChange(pageSize, null, commandObject);
		} else {
			onPageChange(pageSize, currentPageAnchor, commandObject);
		}
	};

	// 点击下一页
	handleNextClick = () => {
		const { onPageChange, pageAnchor, loading } = this.props;
		const { pageSize, nextPageAnchor, currentPageAnchor, cachePrevPageAnchor } = this.state;
		if (!loading) {
			// 点击下一页把当前页添加到缓存锚点中
			cachePrevPageAnchor.push(currentPageAnchor);
			// 点击下一页，前一页为当前页，当前页为下一页，能点击下一页，则前一页一定可以点击
			this.setState({
				prevPageAnchor: currentPageAnchor,
				cachePrevPageAnchor,
				currentPageAnchor: nextPageAnchor,
				prevPageAnchorDisabled: false
			});
			// 回调请求接口，把页码和请求需要的锚点传过去
			onPageChange(pageSize, nextPageAnchor || pageAnchor);
		}
	};

	pageSizeChange = value => {
		const { loading } = this.props;
		if (!loading) {
			// 重置当前状态,请求第一页数据
			this.setState({
				pageSize: value,
				nextPageAnchor: null,
				currentPageAnchor: null,
				prevPageAnchor: null,
				cachePrevPageAnchor: [],
				prevPageAnchorDisabled: false,
				nextPageAnchorDisabled: false
			});
			// 回调请求接口，把页码和请求需要的锚点传过去，传null callApi时会不传锚点，默认返回第一页
			this.props.onPageChange(value, null, this.commandObject);
		}
	};

	//新翻页方法
	onShowSizeChange = (current, pageSize) => {
		// 重置当前状态,请求第一页数据
		this.setState({
			pageNum: pageSize,
			pageSize: pageSize,
			nextPageAnchor: null,
			currentPageAnchor: null,
			prevPageAnchor: null,
			cachePrevPageAnchor: [],
			prevPageAnchorDisabled: false,
			nextPageAnchorDisabled: false
		});
		// 回调请求接口，把页码和请求需要的锚点传过去，传null callApi时会不传锚点，默认返回第一页
		this.props.onPageChange(pageSize, 1, this.commandObject);
	};

	onNewPaginationChange = page => {
		const { pageSize } = this.state;
		const { onPageChange } = this.props;
		// 点击上一页，当前页是缓存中的最后一个锚点，下一个页的锚点为当前页的锚点，能点击前一页，则下一个一定能点击
		this.setState({
			currentPageAnchor: page
		});
		// 回调请求接口，把页码和请求需要的锚点传过去
		onPageChange(pageSize, page);
	};

	// 缓存数据
	cachedParams = () => {
		const state = this.state;
		const { cacheData = true, cacheKey } = this.props;
		if (cacheData) {
			if (cacheKey) {
				cache.setPageState('PaginationTable', cacheKey, state);
			} else {
				cache.setPageState('PaginationTable', 'paginationTable', state);
			}
		}
	};

	// 清除缓存
	clearCache = () => {
		if ('cacheKey' in this.props) {
			cache.delPageState('PaginationTable', this.props.cacheKey);
		} else {
			cache.delPageState('PaginationTable', 'paginationTable');
		}
	};

	render () {
		let {
			pageAnchor,
			pageSize,
			totalNum,
			onPageChange,
			displayNumero,
			customDisplayNumero,
			columns,
			...rest
		} = this.props;
		let {
			prevPageAnchorDisabled,
			nextPageAnchorDisabled,
			cachePrevPageAnchor,
			currentPageAnchor,
			pageNum = 10
		} = this.state;

		pageSize = pageSize.map(v => {
			return v + '';
		});
		//displayNumero显示序号；customDisplayNumero 显示序号，并允许自定义columns配置
		const cols = [...columns];
		if (displayNumero === true || customDisplayNumero) {
			let numeroColumn = {};
			if (this.props.showSizePagination) {
				numeroColumn = {
					title: <span style={{ whiteSpace: 'noWrap' }}>序号</span>,
					width: '50px',
					render: (text, row, index) => {
						if (!currentPageAnchor) {
							currentPageAnchor = 1;
						}
						return (currentPageAnchor - 1) * this.state.pageSize + ++index;
					}
				};
			} else {
				numeroColumn = {
					title: <span style={{ whiteSpace: 'noWrap' }}>序号</span>,
					width: '50px',
					render: (text, row, index) => cachePrevPageAnchor.length * this.state.pageSize + ++index
				};
			}

			if (customDisplayNumero) {
				Object.assign(numeroColumn, customDisplayNumero);
			}
			cols.unshift(numeroColumn);
		}
		const currentPageCount = Number(totalNum / pageNum);
		return (
			<div style={{ overflow: 'hidden' }} className="PaginationTable">
				{/* 默认显示Table 当传入hideTable，且为true时隐藏Table */}
				{!(this.props.hideTable && this.props.hideTable === true)
					? <Table {...rest} columns={cols} pagination={false} />
					: ''
				}
				{!this.props.hidePagination ? (
					this.props.showSizePagination ? (
						<div className="eh-pagination">
							<Pagination
								size="small"
								onChange={(page, pageSize) => this.onNewPaginationChange(page, pageSize)}
								hideOnSinglePage={!totalNum}
								showSizeChanger
								current={currentPageAnchor || 1}
								pageSize={this.state.pageSize}
								onShowSizeChange={(current, pageSize) => this.onShowSizeChange(current, pageSize)}
								total={totalNum}
								showTotal={total => `共 ${total} 条 `}
								showQuickJumper={currentPageCount > 10 || currentPageCount == 10}
								pageSizeOptions={pageSize}
								showLessItems={true}
							/>
						</div>
					) : (
						<div className="eh-pagination">
							<label>每页</label>
							<Select
								value={String(this.state.pageSize)}
								size="small"
								// style={{ width: 50 }}
								onChange={this.pageSizeChange}
							>
								{pageSize.map((value, index) => (
									<Select.Option value={String(value)} key={index}>
										{value}
									</Select.Option>
								))}
							</Select>
							<label>条</label>
							<Button size="small" disabled={prevPageAnchorDisabled} onClick={this.handlePrevClick}>
								<LeftOutlined />
							</Button>
							<Button size="small" disabled={nextPageAnchorDisabled} onClick={this.handleNextClick}>
								<RightOutlined />
							</Button>
						</div>
					)
				) : (
					''
				)}
			</div>
		);
	}
}

PaginationTable.propTypes = {
	// 回调请求接口，把页码和请求需要的锚点传过去
	onPageChange: PropTypes.func,
	// 支持翻页的页数
	pageSize: PropTypes.arrayOf(PropTypes.number),
	// 锚点
	pageAnchor: PropTypes.string,
	// 是否显示分页
	hidePagination: PropTypes.bool,
	// 是否使用页码分页
	showSizePagination: PropTypes.bool,
	// 使用页码分页时的数据总量
	totalNum: PropTypes.number,
	// 是否隐藏表格
	hideTable: PropTypes.bool,
	// 是否显示序号
	displayNumero: PropTypes.bool,
	// 自定义displayNumero 的columns
	customDisplayNumero: PropTypes.object
};

PaginationTable.defaultProps = {
	pageSize: [10, 20, 50]
};

export default PaginationTable;
